<template>
  <v-main>
    <v-container
      fluid
      class="grey lighten-4 fill-height"
      :class="{ 'px-16': $vuetify.breakpoint.mdAndUp }"
    >
      <v-row v-if="!isGuest" align="center" justify="space-around">
        <v-col class="col-12">
          <div id="notebook">
            <div class="class-title">
              <div class="class-title-wrapper">
                <div class="class-description">
                  {{ courseName }} {{ user.grade }}-й клас
                </div>
                <div class="class-lesson-info">
                  <div>
                    Пройдено уроків:
                  </div>
                  <div class="number-lessons">
                    {{ passedLessons }} з {{ lessons.length }}
                  </div>
                </div>
              </div>
              <div v-if="!$vuetify.breakpoint.xsOnly">
                <div class="teacher-description">
                  Звернутися з питанням за предметом можна до вчителя
                  {{ teacher.firstName }} {{ teacher.lastName }}:
                </div>
                <div class="teacher-info">
                  <div id="contact" class="teacher-email">
                    <a
                      :href="
                        'mailto:' + teacher.email + '?subject=' + courseName
                      "
                      >{{ teacher.email }}</a
                    >
                  </div>
                  <!-- <div>або</div>
                  <div>
                    <v-btn large color="primary" outlined
                      >Написати вчителю</v-btn
                    >
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <div v-if="!isGuest" id="notebook">
        <v-row align="center" justify="center" dense>
          <v-col
            v-for="lesson in newLessons"
            :key="lesson.id"
            :cols="4"
            @click="handleClick(lesson)"
          >
            <v-card class="lesson-card" height="150" width="328">
              <v-card-title
                ><span class="card-lesson-name"
                  >Урок {{ lesson.index + 1 }}</span
                ></v-card-title
              >
              <v-card-text class="text--primary">
                <div class="lesson-card">
                  <div class="lesson-card-name">{{ lesson.name }}</div>

                  <div :class="lesson.className">
                    {{ lesson.statusLabel }}
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <v-row v-if="!isGuest" align="center" justify="space-around">
        <v-col class="col-12">
          <div id="notebook">
            <TeacherJournal
              :isTeacher="false"
              :source-store="sourceStoreName"
              @journalEvent="journalEventHandler"
            ></TeacherJournal>
          </div>
        </v-col>
      </v-row>
      <v-row justify="left" align="left">
        <v-col class="col-12">
          <div id="notebook">
            <div class="lesson-header">
              <div class="lesson-label">Уроки</div>
              <div>
                <v-btn large color="primary" outlined @click="toLibrary()"
                  >Підручники та матеріали</v-btn
                >
              </div>
            </div>
            <v-data-table
              :headers="headers"
              :items="lessons"
              :items-per-page="-1"
              class="elevation-1"
            >
              <template v-slot:item="props">
                <tr
                  @click="handleClick(props.item)"
                  class="lesson-table-row"
                  :class="{ 'even-row': props.index % 2 === 0 }"
                >
                  <td class="pa-2">
                    <span>{{ props.item.name }}</span>
                  </td>
                  <td>{{ props.item.evaluation }}</td>
                  <td :class="props.item.className">
                    {{ props.item.statusLabel }}
                  </td>
                  <div
                    v-if="props.item.hasMessages"
                    class="circle-lesson"
                  ></div>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import statesEnum from '@/enums/statesEnum';

import TeacherJournal from '@/components/View/TeacherJournal/TeacherJournal';

export default {
  name: 'ClassPage',
  components: { TeacherJournal },

  data() {
    return {
      sourceStoreName: 'TeacherRoomStore',
      drawer: true,
      color: 'primary',
      colors: ['primary', 'blue', 'success', 'red', 'teal'],
      right: false,
      permanent: true,
      miniVariant: false,
      expandOnHover: false,
      background: false,
      headers: [
        {
          text: 'Тема уроку',
          align: 'start',
          sortable: false,
          value: 'name',
          class: 'test',
          filter: false,
          width: '70%',
        },
        {
          text: 'Оцінка',
          align: 'start',
          sortable: false,
          value: 'evaluation',
          class: 'test',
          filter: false,
        },
        {
          text: 'Статус',
          align: 'start',
          sortable: false,
          value: 'statusLabel',
          class: 'test',
          filter: false,
        },
      ],
    };
  },
  computed: {
    isGuest() {
      return this.$store.getters['UserStore/isGuest']();
    },
    lessons() {
      return this.$store.getters['LessonsStore/getLessons'];
    },
    passedLessons() {
      return this.lessons.filter((less) => {
        return less.status === 3;
      }).length;
    },
    newLessons() {
      const lastPassetIndex = this.lessons.findIndex((less) => {
        return less.status === 2;
      });
      if (lastPassetIndex !== -1) {
        return this.lessons.slice(lastPassetIndex, lastPassetIndex + 3);
      }

      const notStartedIndex = this.lessons.findIndex((less) => {
        return less.status === 0;
      });
      if (notStartedIndex !== -1) {
        return this.lessons.slice(notStartedIndex, notStartedIndex + 3);
      }

      return this.lessons.slice(0, 3);
    },
    teacher() {
      return this.$store.getters['LessonsStore/getTeacher'];
    },
    courseName() {
      return this.$store.getters['LessonsStore/getCourseName'];
    },
    user() {
      return this.$store.getters['UserStore/getUser'];
    },
  },
  created() {
    this.$_loadLessonByQueryParams();
  },
  watch: {
    $route(newRoute) {
      if (newRoute.query.courseId) {
        this.$_loadLessonByQueryParams();
      }
    },
  },
  methods: {
    toLibrary() {
      this.$router.push({ name: statesEnum.LIBRARY });
    },
    $_loadLessonByQueryParams() {
      const courseId = this.$route.query.courseId;
      this.$_loadLessons({ courseId });
    },
    $_loadLessons: function (data) {
      const { courseId } = data;
      this.$store.dispatch('LessonsStore/loadLessons', { courseId });
    },
    journalEventHandler() {},
    hideMenu() {
      this.miniVariant = !this.miniVariant;
    },

    async handleClick(value) {
      this.$router.push({
        name: 'lesson',
        params: { lessonId: value.id },
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="less">
.v-application .grey.lighten-4 {
  max-width: 1032px;
}
.evaluation-label {
  float: right;
}

.not-finished {
  color: #1976d2;
}

.not-started {
  color: aliceblue;
}

.in-progress {
  color: #b319d2;
}

.need-check {
  color: #1976d2;
}
.not-confirmed {
  color: #f44336;
}

.finished {
  color: #2e7d32;
}

.need-rework {
  color: #ff6d00;
}
.circle-lesson {
  position: relative;
  background: red;
  width: 10px;
  height: 10px;
  border-radius: 50px 50px 50px 50px;
  top: 15px;
  left: -13px;
}

.class-title {
  display: flex;
  justify-content: space-between;
  .class-description {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    margin-top: 8px;
  }
  .class-lesson-info {
    display: flex;
    margin-top: 8px;
    .number-lessons {
      padding-left: 8px;
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
    }
  }
  .teacher-description {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */

    text-align: right;
  }
  .teacher-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    div {
      padding: 8px;
    }
    #contact {
      margin-top: 0;
    }
  }
}
.lesson-header {
  display: flex;
  justify-content: space-between;
  div {
    padding-bottom: 18px;
  }
  .lesson-label {
    color: #083c39;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
  }
}
.even-row {
  background: #f5f5f5;
}

tbody {
  tr:hover {
    background-color: #e9fffe !important;
  }
}

.card-lesson-name {
  color: #083c39;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
}

.lesson-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 87px;

  .lesson-card-name {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.lesson-card {
  cursor: pointer;
}

.lesson-table-row {
  cursor: pointer;
}
</style>
